import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, find, save, remove } from '../../services/contractPartner'

function* fetchContractPartnersRefresh() {
  try {
    let fe = JSON.parse(localStorage.getItem('fetchContractPartners'))
    if (fe == null) {
      fe = { size: 10, index: 0, searchTerm: '%20', orderBy: '%20' }
    }
    const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
    yield put({
      type: actions.LIST_CONTRACTPARTNER,
      result,
    })
  } catch (e) {
    console.error('fetchContractPartnersRefresh error', e)
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

function* fetchContractPartners({ size, index, searchTerm, orderBy }) {
  try {
    // Load last params from last session.
    if (!size && !index && !searchTerm && !orderBy) {
      const fe = JSON.parse(localStorage.getItem('fetchContractPartners'))
      if (fe != null) {
        size = fe.size || 10
        index = fe.index || 0
        searchTerm = fe.searchTerm || '%20'
        orderBy = fe.orderBy || '%20'
      } else {
        size = 10
        index = 0
        searchTerm = '%20'
        orderBy = '%20'
      }
    }
    localStorage.setItem(
      'fetchContractPartners',
      JSON.stringify({ size, index, searchTerm, orderBy }),
    )
    yield put({
      type: actions.REQUESTING,
    })
    const result = yield call(list, size, index, searchTerm, orderBy)
    yield put({
      type: actions.LIST_CONTRACTPARTNER,
      result,
    })
  } catch (e) {
    console.error('fetchContractPartners error', e)
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

function* fetchContractPartnerEdit({ id }) {
  try {
    yield put({
      type: actions.REQUESTING,
    })
    const result = yield call(find, id)
    yield put({
      type: actions.EDIT_CONTRACTPARTNER,
      result,
    })
  } catch (e) {
    console.error('fetchContractPartnerEdit error', e)
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

function* fetchContractPartnerSave(values) {
  try {
    const result = yield call(save, values)
    if (result !== null) {
      notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
    }
    yield put({
      type: actions.SAVE_CONTRACTPARTNER_RECIEVED,
      result,
    })
    yield put({
      type: actions.RE_FETCH_CONTRACTPARTNERS,
    })
  } catch (e) {
    console.error('fetchContractPartnerSave error', e)
    notification.error({ message: 'Save failed', description: e.message })
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

function* fetchContractPartnerDelete(values) {
  try {
    const result = yield call(remove, values)
    if (result !== null) {
      notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
    }
    yield put({
      type: actions.DELETE_CONTRACTPARTNER_RECIEVED,
      result,
    })
    yield put({
      type: actions.RE_FETCH_CONTRACTPARTNERS,
    })
  } catch (e) {
    console.error('fetchContractPartnerDelete error', e)
    notification.error({ message: 'Delete failed', description: e.message })
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_CONTRACTPARTNERS, fetchContractPartners),
    takeEvery(actions.FETCH_CONTRACTPARTNER, fetchContractPartnerEdit),
    takeEvery(actions.SAVE_CONTRACTPARTNER, fetchContractPartnerSave),
    takeEvery(actions.DELETE_CONTRACTPARTNER, fetchContractPartnerDelete),
    takeEvery(actions.RE_FETCH_CONTRACTPARTNERS, fetchContractPartnersRefresh),
  ])
}